export default "https://cdn-static.gokick.com/assets/ec4df3605d889435bba193590f9e5f4fca0b05f8/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";